export default __webpack_public_path__ + "static/red-design-22557e9dedaf9df77d0bd161379fab0d.svg";